<template>
  <div class="login-wrap">
    <el-form v-show="showLogin" label-position="right" :model="login" :rules="loginRules" ref="login"
      label-width="100px" class="demo-ruleForm login-container">
      <h3 class="title">用户登录</h3>
      <el-form-item prop="hospitalNumber" label="用户编号">
        <el-input type="text" v-model="login.hospitalNumber" auto-complete="off" placeholder="请输入用户编号"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input type="password" show-password v-model="login.password" auto-complete="off"
          placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox>
      <el-form-item>
        <el-button type="primary" style="width: 100%" @click="loginSubmit('login')" :loading="logining">登录</el-button>
      </el-form-item>
      <el-button type="text" @click="(showHospital = true), (showLogin = false)">医院信息登记</el-button>
    </el-form>

    <el-form v-show="showHospital" label-position="right" :model="hospital" :rules="hospitalRules" ref="hospital"
      label-width="145px" class="demo-ruleForm login-container">
      <h3 class="title">医院信息登记</h3>
      <el-form-item prop="hospitalNumber" label="医院编号">
        <el-input type="text" v-model="hospital.hospitalNumber" auto-complete="off"
          placeholder="请输入医院编号(本平台账号需与现患率调查平台账号一致)"></el-input>
      </el-form-item>
      <el-form-item prop="hospitalName" label="医院名称">
        <el-input type="text" v-model="hospital.hospitalName" auto-complete="off" placeholder="请输入医院名称"></el-input>
      </el-form-item>
      <el-form-item prop="hospitalLevel" label="医院等级">
        <el-select style="width: 100%" v-model="hospital.hospitalLevel" filterable placeholder="请选择医院等级">
          <el-option v-for="item in allHospitalLevel" :key="item.hospitalLevel" :label="item.hospitalLevel"
            :value="item.hospitalLevel">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hospitalType" label="医院类型">
        <el-select style="width: 100%" v-model="hospital.hospitalType" filterable placeholder="请选择医院类型">
          <el-option v-for="item in allHospitalType" :key="item.hospitalType" :label="item.hospitalType"
            :value="item.hospitalType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hospitalNature" label="医院种类">
        <el-select style="width: 100%" v-model="hospital.hospitalNature" filterable placeholder="请选择医院种类">
          <el-option v-for="item in allHospitalNature" :key="item.hospitalNature" :label="item.hospitalNature"
            :value="item.hospitalNature">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hospitalProperty" label="医院性质">
        <el-select style="width: 100%" v-model="hospital.hospitalProperty" filterable placeholder="请选择医院性质">
          <el-option v-for="item in allHospitalProperty" :key="item.hospitalProperty" :label="item.hospitalProperty"
            :value="item.hospitalProperty">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hospitalNumberOfBed" label="床位数">
        <el-input-number v-model="hospital.hospitalNumberOfBed"></el-input-number>
      </el-form-item>
      <el-form-item prop="area" label="所属地区">
        <el-cascader filterable clearable v-model="hospital.area" :options="area" style="width: 100%"></el-cascader>
      </el-form-item>
      <el-form-item prop="source" label="数据来源">
        <el-select style="width: 100%" v-model="hospital.source" filterable placeholder="请选择数据来源">
          <el-option v-for="item in allsource" :key="item.source" :label="item.source" :value="item.source">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isUseSystem" label="使用院感信息系统">
        <el-select style="width: 100%" v-model="hospital.isUseSystem" filterable placeholder="请选择是否使用院感信息系统">
          <el-option v-for="item in allSystem" :key="item.source" :label="item.source" :value="item.source">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="hospitalAddress" label="医院地址">
        <el-input type="text" v-model="hospital.hospitalAddress" auto-complete="off" placeholder="请输入医院地址"></el-input>
      </el-form-item>
      <el-form-item prop="officeFZR" label="办公室负责人">
        <el-input type="text" v-model="hospital.officeFZR" auto-complete="off" placeholder="请输入办公室负责人"></el-input>
      </el-form-item>
      <el-form-item prop="officeFZRphone" label="办公室负责人电话">
        <el-input type="text" v-model="hospital.officeFZRphone" auto-complete="off"
          placeholder="请输入办公室负责人电话"></el-input>
      </el-form-item>
      <el-form-item prop="officeLXR" label="办公室联系人">
        <el-input type="text" v-model="hospital.officeLXR" auto-complete="off" placeholder="请输入办公室联系人"></el-input>
      </el-form-item>
      <el-form-item prop="officeLXRphone" label="办公室联系人电话">
        <el-input type="text" v-model="hospital.officeLXRphone" auto-complete="off"
          placeholder="请输入办公室联系人电话"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width: 100%" @click="hospitalSubmit('hospital')"
          :loading="logining">提交</el-button>
        <el-button type="text" style="float: right" @click="(showLogin = true), (showHospital = false)">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from "../api/user";
import { signInHospital, getAllArea } from "../api/hospital";
import { setCookie, getCookie, delCookie } from "../utils/util";
import md5 from "js-md5";
import { regionData, codeToText } from "element-china-area-data";
import { matchHospitalNumber } from "../api/user";

export default {
  name: "login",
  data() {
    return {
      area: [],
      logining: false,
      rememberpwd: false,
      showLogin: true,
      login: {
        hospitalNumber: "",
        password: "",
        // code: "",
        // codeimg: "",
      },
      showHospital: false,
      hospital: {
        hospitalNumber: "",
        hospitalName: "",
        hospitalLevel: "",
        hospitalType: "",
        hospitalNature: "",
        hospitalProperty: "",
        hospitalNumberOfBed: "",
        area: "",
        hospitalAddress: "",
        officeFZR: "",
        officeFZRphone: "",
        officeLXR: "",
        officeLXRphone: "",
        source: "",
        isUseSystem: ''
      },
      allHospitalLevel: [
        { hospitalLevel: "一级甲等" },
        { hospitalLevel: "一级丙等" },
        { hospitalLevel: "一级乙等" },
        { hospitalLevel: "一级未定级" },
        { hospitalLevel: "二级甲等" },
        { hospitalLevel: "二级乙等" },
        { hospitalLevel: "二级丙等" },
        { hospitalLevel: "二级未定级" },
        { hospitalLevel: "三级特等" },
        { hospitalLevel: "三级甲等" },
        { hospitalLevel: "三级丙等" },
        { hospitalLevel: "三级乙等" },
        { hospitalLevel: "三级未定级" },
        { hospitalLevel: "未评级" },
      ],
      allHospitalType: [
        { hospitalType: "综合医院" },
        { hospitalType: "中医医院" },
        { hospitalType: "中西医结合医院" },
        { hospitalType: "民族医院" },
        { hospitalType: "专科医院" },
        { hospitalType: "康复医院" },
        { hospitalType: "妇幼保健院" },
      ],
      allHospitalNature: [
        { hospitalNature: "大学院校附属医院" },
        { hospitalNature: "非大学院校附属医院" },
      ],
      allHospitalProperty: [
        { hospitalProperty: "公立医院" },
        { hospitalProperty: "私营医院" },
      ],
      allsource: [{ source: "全院" }, { source: "ICU" }],
      allSystem: [{ source: "是" }, { source: "否" }],
      loginRules: {
        hospitalNumber: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      hospitalRules: {
        hospitalNumber: [
          { required: true, message: "请输入医院编号(本平台账号需与现患率调查平台账号一致)", trigger: "blur" },
        ],
        hospitalName: [
          { required: true, message: "请输入医院名称", trigger: "blur" },
        ],
        hospitalLevel: [
          { required: true, message: "请选择医院等级", trigger: "blur" },
        ],
        source: [
          { required: true, message: "请选择数据来源", trigger: "blur" },
        ],
        isUseSystem: [
          { required: true, message: "请选择是否使用院感信息系统", trigger: "blur" },
        ],
        hospitalType: [
          { required: true, message: "请选择医院类型", trigger: "blur" },
        ],
        hospitalNature: [
          { required: true, message: "请选择医院种类", trigger: "blur" },
        ],
        hospitalProperty: [
          { required: true, message: "请选择医院性质", trigger: "blur" },
        ],
        hospitalNumberOfBed: [
          { required: true, message: "请输入医院床位数", trigger: "blur" },
        ],
        area: [{ required: true, message: "请选择所属地区", trigger: "blur" }],
        hospitalAddress: [
          { required: true, message: "请输入医院地址", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // 获取图形验证码
    // this.getcode()
    // 获取存在本地的用户名密码
    this.getuserpwd();
    this.getAllArea();
  },
  methods: {
    hospitalSubmit(formName) {
      matchHospitalNumber({ hospitalCode: this.hospital.hospitalNumber }).then((res) => {
        if (res.data.length < 1) {
          this.$alert('医院账号信息与现患率调查平台账号不一致,请修改医院编号', '提示', {
            confirmButtonText: '确定',
            callback: action => { }
          });
        } else {
          this.hospital.area = this.hospital.area.toString();
          this.$refs[formName].validate((valid) => {
            if (valid) {
              signInHospital(this.hospital).then((res) => {
                if (res.data > 0) {
                  this.$message.success("医院信息登记成功");
                  this.showLogin = true;
                  this.showHospital = false;
                } else this.$message.error(res.msg);
              });
            } else {
              this.$message.error("请将医院信息填写完整!");
              this.logining = false;
              return false;
            }
          });
        }
      });
    },
    isNumber(value) {
      return /^\d+$/.test(value)
    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.login.username = getCookie("user");
        this.login.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },
    //获取info列表
    loginSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          login(this.login).then((res) => {
            if (this.rememberpwd) {
              //保存帐号到cookie，有效期7天
              setCookie("hospitalNumber", this.login.username, 7);
              //保存密码到cookie，有效期7天
              setCookie("password", this.login.password, 7);
            } else {
              delCookie("hospitalNumber");
              delCookie("password");
            }
            if (res.data.length < 1) {
              this.logining = false;
              return
            }
            //如果请求成功就让他2秒跳转路由
            setTimeout(() => {
              this.logining = false;
              // 缓存token
              // localStorage.setItem('logintoken', res.data.token)
              // 缓存用户个人信息
              localStorage.setItem("userdata", JSON.stringify(res.data));
              this.$store.commit("login", "true");
              this.$router.push({ path: "/goods/Goods" });
            }, 1000);
          });
        } else {
          // 获取图形验证码
          // this.getcode()
          this.$message.error("请输入用户名密码！");
          this.logining = false;
          return false;
        }
      });
    },
    getAllArea() {
      this.area = [];
      getAllArea().then((res) => {
        this.area.push({
          value: res.data1[0].id,
          label: res.data1[0].name,
          children: [],
        });
        for (let i = 0; i < res.data2.length; i++) {
          this.area[0].children.push({
            value: res.data2[i].id,
            label: res.data2[i].name,
            children: [],
          });
        }
        for (let i = 0; i < res.data3.length; i++) {
          if (res.data3[i].cityid == 235) {
            this.area[0].children[0].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 236) {
            this.area[0].children[1].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 237) {
            this.area[0].children[2].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 238) {
            this.area[0].children[3].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 239) {
            this.area[0].children[4].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 240) {
            this.area[0].children[5].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 241) {
            this.area[0].children[6].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 242) {
            this.area[0].children[7].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 243) {
            this.area[0].children[8].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 244) {
            this.area[0].children[9].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 245) {
            this.area[0].children[10].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 246) {
            this.area[0].children[11].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 247) {
            this.area[0].children[12].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 248) {
            this.area[0].children[13].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 249) {
            this.area[0].children[14].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 250) {
            this.area[0].children[15].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 251) {
            this.area[0].children[16].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 252) {
            this.area[0].children[17].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 253) {
            this.area[0].children[18].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 254) {
            this.area[0].children[19].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
          if (res.data3[i].cityid == 255) {
            this.area[0].children[20].children.push({
              value: res.data3[i].id,
              label: res.data3[i].name,
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  background-image: url(data:image/svg+xml;base64,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);
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 10px auto;
  width: 500px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue